exports.default = {
  'not_found_message': '饶了地球一圈，还是没有找到您要的页面'
}
